import { createElement } from 'react';
import Icon from '@material-ui/core/Icon';
import PropTypes from 'prop-types';

import './muifonts.css'; // this lazy loads material icons
import * as CustomIcons from './Icons';

export const LEGACY_ICON_PREFIX = 'ipm-icons-';

const ICON_MAP = {
    [`${LEGACY_ICON_PREFIX}add-filter`]: CustomIcons.AddFilter,
    [`${LEGACY_ICON_PREFIX}agent2k`]: CustomIcons.NPoint2K,
    [`${LEGACY_ICON_PREFIX}agent3k`]: CustomIcons.NPoint3K,
    [`${LEGACY_ICON_PREFIX}agent4k`]: CustomIcons.NPoint4K,
    [`${LEGACY_ICON_PREFIX}agent4kw`]: CustomIcons.NPoint4KW,
    [`${LEGACY_ICON_PREFIX}agent3kg`]: CustomIcons.NPoint3KG,
    [`${LEGACY_ICON_PREFIX}autorefresh`]: CustomIcons.AutoRefresh,
    [`${LEGACY_ICON_PREFIX}check-circle-off`]: CustomIcons.CheckCircleOff,
    [`${LEGACY_ICON_PREFIX}comparison-period`]: CustomIcons.ComparisonPeriod,
    [`${LEGACY_ICON_PREFIX}comparison-period-after`]: CustomIcons.ComparisonPeriodAfter,
    [`${LEGACY_ICON_PREFIX}comparison-period-before`]: CustomIcons.ComparisonPeriodBefore,
    [`${LEGACY_ICON_PREFIX}content-copy`]: CustomIcons.ContentCopy,
    [`${LEGACY_ICON_PREFIX}docker`]: CustomIcons.Docker,
    [`${LEGACY_ICON_PREFIX}jump-reporting.svg`]: CustomIcons.JumpReporting,
    [`${LEGACY_ICON_PREFIX}jump-settings.svg`]: CustomIcons.JumpSettings,
    [`${LEGACY_ICON_PREFIX}linux`]: CustomIcons.Linux,
    [`${LEGACY_ICON_PREFIX}network-device`]: CustomIcons.NetworkDevice,
    [`${LEGACY_ICON_PREFIX}path-ellipsis`]: CustomIcons.PathEllipsis,
    [`${LEGACY_ICON_PREFIX}plc`]: CustomIcons.Plc,
    [`${LEGACY_ICON_PREFIX}plm`]: CustomIcons.Plm,
    [`${LEGACY_ICON_PREFIX}refresh`]: CustomIcons.Refresh,
    [`${LEGACY_ICON_PREFIX}testagent`]: CustomIcons.TestAgent,
    [`${LEGACY_ICON_PREFIX}vmware-hypervisor`]: CustomIcons.VmwareHypervisor,
    [`${LEGACY_ICON_PREFIX}vmware-vm`]: CustomIcons.VmwareVm,
    [`${LEGACY_ICON_PREFIX}windows`]: CustomIcons.Windows,
};

/**
 * There are a few areas in the back-end which return the actual icon name to use instead of
 * a parameter and then letting the UI decide what to do with it (i.e., the nPoint list's typeIcon).
 * Since we don't use class names anymore, names like "ipm-icons-agent3k" are useless here. We need
 * to translate them to the actual icon.
 *
 * MattN's Opinion Corner: this is why the backend should never dictate what icon we should use. This should
 * have been determined by the UI based on the type of nPoint. The backend should not have to know the names
 * of the icons the UI uses...
 *
 * @param {String} legacyIcon
 */
export function LegacyIcon(props) {
    // eslint-ignore
    const { icon, fontSize, useMaterial } = props;
    const iconCmp = ICON_MAP[icon];

    if (iconCmp) {
        return createElement(iconCmp, { fontSize });
    }

    if (!iconCmp && useMaterial === true) {
        return <MaterialUiIcon icon={icon} fontSize={fontSize} />;
    }

    return <div>??</div>;
}

export function MaterialUiIcon(props) {
    const { icon, fontSize } = props;

    return <Icon fontSize={fontSize}>{icon}</Icon>;
}

// ---- Prop Types ----

LegacyIcon.defaultProps = {
    useMaterial: true,
};

LegacyIcon.propTypes = {
    icon: PropTypes.string.isRequired,
    useMaterial: PropTypes.bool,
    fontSize: PropTypes.string, // eslint-disable-line react/require-default-props
};

MaterialUiIcon.propTypes = {
    icon: PropTypes.string.isRequired,
    fontSize: PropTypes.string, // eslint-disable-line react/require-default-props
};
